import { createAction, props } from '@ngrx/store';

export const callToActionClicked = createAction(
  '[Home] call to action clicked',
  props<{ buttonId: string }>()
);
